<template>
  <transition name="fade">
    <div class="modal modal-default">
      <div class="modal__overlay" @click="$emit('close')"></div>
      <div class="small-modal">
        <div class="small-modal__close" @click="$emit('close')">X</div>
        <div class="small-modal__head">
          <span>L’import a été effectué avec succès</span>
        </div>

        <div class="small-modal__body">
          <template v-if="!isSending">
            <table class="import-response">
            <tbody>
              <tr>
                <td class="title-td">Nombre total de garanties dans le fichier:</td>
                <td class="value-td" v-if="result.total">{{result.total.length}}</td>
              </tr>
              <tr>
                <td class="title-td">Nombre de garanties importées:</td>
                <td class="value-td" v-if="result.unique">{{result.unique.length}}</td>
              </tr>
              <tr>
                <td class="title-td">Nombre de garanties dupliquées:</td>
                <td class="value-td" v-if="result.duplicates">{{result.duplicates.length}}</td>
              </tr>
              <tr>
                <td class="title-td">Nombre de garanties non importées:</td>
                <td class="value-td" v-if="result.wrongs">{{result.wrongs.length}}</td>
              </tr>
              <tr>
                <td class="title-td">Voulez-vous télécharger le fichier des garanties non importées ?</td>
                <td><button class="btn btn-info" @click="onWrongExport">Exporter</button></td>
              </tr>
              <tr>
                <td class="title-td">Voulez-vous télécharger le fichier des garanties dupliquées ?</td>
                <td><button class="btn btn-info" @click="onDuplicateExport">Exporter</button></td>
              </tr>
            </tbody>
          </table>
          </template>
          <template v-else>
            Loading...
          </template>
        </div>

        <div class="small-modal__footer">
          <div class="small-modal__footer__actions d-flex justify-content-between">
            <button class="blue-button" @click="$emit('close')">
              <span>Close</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

  import Preloader from '@/components/Preloader'

  export default {
    name: 'GarantieSubscriptipnModal',
    components: {
      Preloader
    },
    props: {
      result: Object,
      isShown: Boolean,
    },
    data() {
      return {
        isSending: false
      }
    },
    computed: {},
    watch: {
      'isShown' : function() {

      }
    },
    methods: {
      redirectForDownloading() {
        this.$emit('close');
      },
      onDuplicateExport() {
        this.isSending = true;
        // console.log('duplicates');
        // console.log(this.result.duplicates);
        let url = `guarantees/import/duplicates_prepare`;
        let data = {
          ids: this.result.duplicates || []
        };
        let ids = this.result.duplicates || [];

        this.apiPostFormData(url, {ids})
                .then(response => {
                  this.isSending = false;
                  window.location.href = this.getApiAuthUrl(`guarantees/import/duplicates_post_certified`) + `&key=${response.data.key}`;
                })
                .catch(error => {
                  this.isSending = false;
                  this.showErrorNotification(error)
                });
      },
      onWrongExport() {
        console.log('wrong');
        console.log(this.result.wrongs);

        let url = `guarantees/import/wrongs_prepare`;
        let data = {quotes : this.result.wrongs};

        this.apiPostFormData(url, data)
                .then(response => {
                  this.isSending = false;
                  window.location.href = this.getApiAuthUrl(`guarantees/import/wrongs_post_certified`) + `&key=${response.data.key}`;
                })
                .catch(error => {
                  this.isSending = false;
                  this.showErrorNotification(error)
                });
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Garantie/GarantieSubscriptionModal.vue